import { Lock } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { PasswordInput } from '@/components/sv/password-input'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import type { ReactNode } from 'react'

const DEFAULT_DESCRIPTION = 'Enter your Sevalla password to continue.'

type PanelProps = {
  description?: ReactNode
  children: ReactNode
}

export const PasswordConfirmPanel = ({
  description = DEFAULT_DESCRIPTION,
  children,
}: PanelProps) => {
  return (
    <div className="flex flex-col gap-3 rounded-lg border bg-muted/30 p-4">
      <div className="flex items-start gap-3">
        <div className="flex size-8 shrink-0 items-center justify-center rounded-md bg-muted text-foreground">
          <Lock className="size-4" aria-hidden="true" />
        </div>
        <div className="flex flex-col gap-0.5">
          <p className="text-sm font-medium">Confirm it's you</p>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      {children}
    </div>
  )
}

type FieldProps = {
  name?: string
  description?: ReactNode
  isDisabled?: boolean
}

export const PasswordConfirmField = ({
  name = 'password',
  description,
  isDisabled = false,
}: FieldProps) => {
  const { control } = useFormContext()

  return (
    <PasswordConfirmPanel description={description}>
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Password</FormLabel>
            <FormControl>
              <PasswordInput
                autoComplete="off"
                disabled={isDisabled}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </PasswordConfirmPanel>
  )
}
